<template>
  <BaseDialogForm
    v-model="showAddSalesDeliveryForm"
    :title="`Edit ${orderModule.sales} ${orderType} ${orderModule.order}`"
    :nonFieldErrors="formErrors.non_field_errors"
    :fullscreen="false"
    max-width="40%"
  >
    <template #content>
      {{ formErrors.non_field_errors }}
      <v-form
        v-model="isValid"
        ref="integrationSalesDeliveryForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0 pa-0">
          <v-col cols="12" class="pa-0 pr-lg-2">
            <p class="text-caption text-truncate mb-0">
              actual value: {{ actualOrderDetails.order_date }}
            </p>
            <DatePicker
              type="date"
              outlined
              :label="`${orderModule.order} Date*`"
              :min="returnToday()"
              :rules="[(val) => !!val || `${orderModule.order} Date is required`]"
              v-model="orderDetails.order_date"
              :error-messages="formErrors.order_date"
              @input="delete formErrors.order_date"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <SecondaryButton
        id="salesDeliveryOrderFormReset"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="salesDeliveryOrderFormReset"
        @click="submitForm()"
        :disabled="!isValid"
        btnClass="text-uppercase rounded-lg"
        name="submit"
      >
      </PrimaryButton>
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { maxOrderQuantity, minOrderQuantity } from "@/utils/validation.js";

import { errorInSubArrayHandler, returnToday, deepCopy } from "@/utils/functions";
import { bus } from "@/main.js";
import {
  orderModule,
  customerModule,
  configurationModule,
  customerAddressModule,
} from "@/utils/moduleMapping";
export default {
  components: { BaseDialogForm },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: Number,
    },
    orderType: {
      type: String,
      default: "Delivery",
    },
    branchList: {
      type: Array,
    },
    itemList: {
      type: Array,
    },
    paymentMethodList: {
      type: Array,
    },
    currencyList: {
      type: Array,
    },
  },
  data() {
    return {
      orderModule,
      customerModule,
      configurationModule,
      customerAddressModule,
      errorInSubArrayHandler,
      returnToday,
      minOrderQuantity,
      maxOrderQuantity,
      formCount: 0,
      isValid: true,
      orderDetails: { order_items: [{}] },
      formErrors: {},
      actualFormErrors: {},
      actualOrderDetails: {},
      customerAddressList: [],
      addressDetails: {},
      projectList: [],
      warehouseList: [],
      customerList: [],
      branchDetails: {},
      orderPayload: {},
      paymentMethodType: null,
      defaultCurrencyId: null,
      selectedCustomer: null,
    };
  },
  computed: {
    showAddSalesDeliveryForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    selectedItemIds() {
      return this.orderDetails.order_items.map((itemObj) => {
        if (typeof itemObj.item == typeof {}) {
          return itemObj.item.id;
        } else {
          return itemObj.item;
        }
      });
    },
    orderWeight() {
      if (this.orderDetails.order_items) {
        return this.orderDetails.order_items
          .map((v) =>
            v && v.item_weight
              ? v.item_weight * parseFloat(v.original_quantity ? v.original_quantity : 0)
              : v && v.item && v.item.weight
              ? v.item.weight * parseFloat(v.original_quantity ? v.original_quantity : 0)
              : null
          )
          .filter((v) => v != null)
          .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
          .toFixed(2);
      }
      return null;
    },
    orderCbm() {
      if (this.orderDetails.order_items) {
        return this.orderDetails.order_items
          .map((v) =>
            v && v.item_volume
              ? v.item_volume * parseFloat(v.original_quantity ? v.original_quantity : 0)
              : v && v.item && v.item.volume
              ? v.item.volume * parseFloat(v.original_quantity ? v.original_quantity : 0)
              : null
          )
          .filter((v) => v != null)
          .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
          .toFixed(4);
      }
      return null;
    },
    userDetails() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj;
      }
      return null;
    },
  },
  watch: {
    showAddSalesDeliveryForm(value) {
      if (value) {
        this.populateOrderIntegrationForm(this.orderId, this.orderType);
      } else {
        this.closeDialog();
      }
    },
  },
  methods: {
    async onBranchChange(branch_id) {
      if (!branch_id) {
        return;
      }
      this.$api.branch
        .getBranchDetail(branch_id)
        .then((res) => {
          this.branchDetails = res.data;
          this.orderDetails = {
            ...this.orderDetails,
            currency_code: res.data.currency,
          };
        })
        .catch((err) => {
          console.log(err);
        });
      await this.getCustomerList(branch_id);
      await this.getProjectSelectList(branch_id);
      await this.getCustomerAddressList(branch_id);
      await this.getWarehouseList(branch_id);
      if (this.customerAddressList) {
        let selectCustomerAddress = this.customerAddressList.find(
          (customerAddress) =>
            customerAddress.location_id.toLowerCase() ==
            this.orderDetails.location_id.toString().toLowerCase()
        );
        if (selectCustomerAddress) {
          this.orderDetails.location_id = selectCustomerAddress.id;
          await this.getCustomerList(branch_id);
          if (this.customerList) {
            let selectCustomer = this.customerList.find(
              (customer) =>
                customer.code.toLowerCase() ==
                selectCustomerAddress.customer_code.toString().toLowerCase()
            );
            if (selectCustomer) {
              this.selectedCustomer = selectCustomer.id;
              this.customerChanged(selectCustomer.id);
            }
          }
        }
      }
    },
    removeItem(index) {
      this.orderDetails.order_items.splice(index, 1);
    },
    async getProjectSelectList(id) {
      if (id) {
        this.$api.project
          .getProjectSelectList({ limit: "all", branch: id })
          .then((res) => {
            this.projectList = res.data;
            // let defaultProject = this.projectList.find((v) => v.is_default);
            // this.orderDetails.project = defaultProject?.id;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.projectList = [];
      }
    },
    async getWarehouseList(branch_id) {
      return this.$api.warehouse
        .getWarehouseSelectList({ limit: "all", branch: branch_id })
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async processOrderDetailData() {
      if (this.orderDetails.branch_code) {
        let selectBranch = this.branchList.find(
          (branch) =>
            branch.code.toLowerCase() ==
            this.orderDetails.branch_code.toString().toLowerCase()
        );

        if (selectBranch) {
          this.orderDetails.branch_code = selectBranch.id;
          this.defaultCurrencyId = selectBranch.currency;

          await this.getProjectSelectList(selectBranch.id);
          await this.getWarehouseList(selectBranch.id);
          await this.getCustomerAddressList(selectBranch.id);
          await this.getCustomerList(selectBranch.id);

          if (this.projectList) {
            let selectProject = this.projectList.find(
              (project) =>
                project.code.toLowerCase() ==
                this.orderDetails.project_code.toString().toLowerCase()
            );
            if (selectProject) {
              this.orderDetails.project_code = selectProject.id;
            }
          }
          if (this.orderType == "Pickup" && this.orderDetails.warehouse_id) {
            let selectWarehouse = this.warehouseList.find(
              (warehouse) =>
                warehouse.warehouse_id.toString().toLowerCase() ==
                this.orderDetails.warehouse_id.toString().toLowerCase()
            );
            this.orderDetails.warehouse_id = selectWarehouse ? selectWarehouse.id : null;
          }
          if (this.orderDetails.location_id) {
            if (this.customerAddressList) {
              let selectCustomerAddress = this.customerAddressList.find(
                (customerAddress) =>
                  customerAddress.location_id.toLowerCase() ==
                  this.orderDetails.location_id.toString().toLowerCase()
              );
              if (selectCustomerAddress) {
                this.orderDetails.location_id = selectCustomerAddress.id;
                if (this.customerList) {
                  let selectCustomer = this.customerList.find(
                    (customer) =>
                      customer.code.toString().toLowerCase() ==
                      selectCustomerAddress.customer_code.toString().toLowerCase()
                  );
                  if (selectCustomer) {
                    this.selectedCustomer = selectCustomer.id;
                    this.customerChanged(selectCustomer.id);
                  }
                }
              }
            }
          }
        } else {
          this.orderDetails.branch_code = null;
        }
      }
      if (this.orderDetails.payment_method) {
        let paymentMethod = this.paymentMethodList.find(
          (paymentMethod) =>
            paymentMethod.name.toLowerCase() ==
            this.orderDetails.payment_method.toString().toLowerCase()
        );

        if (paymentMethod) {
          this.orderDetails.payment_method = paymentMethod.id;
          this.onPaymentChange(paymentMethod);
        }
      }
      if (this.orderDetails.currency_code) {
        let currencyCode = this.currencyList.find(
          (currencyCode) =>
            currencyCode.code.toLowerCase() ==
            this.orderDetails.currency_code.toString().toLowerCase()
        );

        if (currencyCode) {
          this.orderDetails.currency_code = currencyCode.id;
        } else {
          this.orderDetails.currency_code = this.defaultCurrencyId;
        }
      } else {
        this.orderDetails.currency_code = this.defaultCurrencyId;
      }
      if (this.orderDetails && this.orderDetails.order_items) {
        let order_items = [];
        for (let i = 0; i < this.orderDetails.order_items.length; i++) {
          let order_item = {
            quantity: this.orderDetails.order_items[i].quantity,
          };
          if (this.orderType == "Delivery") {
            let selectWarehouse = this.warehouseList.find(
              (warehouse) =>
                warehouse.warehouse_id.toLowerCase() ==
                this.orderDetails.order_items[i].warehouse_id?.toString().toLowerCase()
            );
            order_item.warehouse_id = selectWarehouse ? selectWarehouse.id : null;
          }

          let selectItem = this.itemList.find(
            (item) =>
              item.item_no.toLowerCase() ==
              this.orderDetails.order_items[i].item_no?.toString().toLowerCase()
          );
          order_item.item_no = selectItem ? selectItem.id : null;

          order_items.push(order_item);
        }
        this.orderDetails.order_items = order_items;
      }
    },
    async populateOrderIntegrationForm(id) {
      try {
        bus.$emit("showLoader", true);
        // if (order_type) {
        //   if (order_type.toString().toLowerCase() == "pickup") {
        //     this.orderType = "Pickup";
        //   } else {
        //     this.orderType = "Delivery";
        //   }
        // }
        const res = await this.$api.integration.getIntegrationOrderDetails(id);

        this.oldId = id;
        this.formErrors = res.data.error;
        this.orderDetails = res.data.payload;
        this.actualOrderDetails = deepCopy(res.data.payload);
        this.actualFormErrors = deepCopy(res.data.error);

        await this.processOrderDetailData();
        bus.$emit("showLoader", false);
      } catch (error) {
        // Handle the error appropriately
        bus.$emit("showLoader", false);

        console.error(error);
      }
    },

    async getCustomerAddressList(branch_id, customer_id) {
      return this.$api.customerAddress
        .getCustomerAddressSelectList({
          limit: "all",
          branch: branch_id,
          customer: customer_id,
        })
        .then((res) => {
          this.customerAddressList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getCustomerList(branch_id) {
      return this.$api.customer
        .getCustomerSelectList({ limit: "all", branch: branch_id })
        .then((res) => {
          this.customerList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addItem() {
      if (this.orderDetails.order_items) {
        this.orderDetails.order_items.push({});
      } else {
        this.orderDetails = {
          ...this.orderDetails,
          order_items: [{}],
        };
      }
    },
    calculateItemWeight(item) {
      if (item.item && item.item.weight) {
        return (
          Math.round(
            (item.original_quantity * parseFloat(item.item.weight) + Number.EPSILON) * 100
          ) / 100
        );
      } else {
        return (
          Math.round(
            (item.original_quantity * parseFloat(item.item_weight) + Number.EPSILON) * 100
          ) / 100
        );
      }
    },
    calculateItemCbm(item) {
      if (item.item && item.item.volume) {
        return parseFloat(
          (item.original_quantity * parseFloat(item.item.volume)).toFixed(4)
        );
      } else {
        return parseFloat(
          (item.original_quantity * parseFloat(item.item_volume)).toFixed(4)
        );
      }
    },
    onPaymentChange(obj) {
      if (obj?.type && obj.type == "prepaid") {
        delete this.orderDetails.order_value;
        delete this.orderDetails.currency_code;
      }
      this.paymentMethodType = obj.type;
    },
    async customerChanged(customer_id) {
      if (customer_id) {
        await this.getCustomerAddressList(this.orderDetails.branch_code, customer_id);
      } else {
        this.customerAddressList = [];
        this.orderDetails.customer_address = null;
      }
    },
    closeDialog() {
      this.showAddSalesDeliveryForm = false;
      this.orderDetails = {};
      this.formErrors = {};
      this.nonFieldError = [];
      this.selectedCustomer = null;
    },
    async resetForm() {
      this.orderDetails = { ...this.actualOrderDetails };
      this.formErrors = { ...this.actualFormErrors };
      this.selectedCustomer = null;
      await this.processOrderDetailData();
    },
    submitForm() {
      bus.$emit("showLoader", true);
      const orderApi =
        this.orderType === "Pickup"
          ? this.$api.orderNew.integrationSalesPickupOrderUpdate
          : this.$api.orderNew.integrationSalesDeliveryOrderUpdate;
      this.orderPayload = { ...this.orderDetails };
      this.orderPayload.payment_method =
        this.orderDetails.payment_method?.id || this.orderDetails.payment_method;
      orderApi({ ...this.orderPayload })
        .then(() => {
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "order created successfully",
            color: "success",
          });
          this.closeDialog();
          this.$emit("refresh-order-logs-list", this.oldId);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
          this.formErrors = err.data;
        });
    },
  },
};
</script>

<style></style>
